import { debugChromecastRequest } from '../../components/Player/helpers/ChromeCast';
import { getAltiboxApiUrl, getAtsUrl, getBaseUrl } from '../../config';
import { PlayablePlaybackOption } from '../../queries/ats/titles/types/playback-option';
import { PlayableTitle } from '../../queries/ats/titles/types/title';

interface CastAtsStreamOptions {
  title: PlayableTitle;
  playbackOption: PlayablePlaybackOption;
  session: cast.framework.CastSession;
  isTrailer: boolean;
  position: number;
}

export async function castAtsStream(options: CastAtsStreamOptions) {
  const { title, playbackOption, session, isTrailer, position } = options;

  let mediaInfo = new window.chrome.cast.media.MediaInfo('mpd-not-set', 'video/mp4');

  mediaInfo.metadata = createMetadata(title, isTrailer);
  mediaInfo.customData = createCustomData(title, playbackOption, isTrailer);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (mediaInfo as any).currentTime = position;

  const request = new window.chrome.cast.media.LoadRequest(mediaInfo);
  request.currentTime = position;

  debugChromecastRequest(request);
  await session.loadMedia(request);
}

function createCustomData(title: PlayableTitle, playbackOption: PlayablePlaybackOption, isTrailer: boolean) {
  return {
    isTrailer,
    platformTitleId: playbackOption.platformTitleId,
    providerId: playbackOption.providerIdentifier,
    masterId: title.masterId,
    huaweiEdsUrl: getBaseUrl(),
    altiboxUrl: getAltiboxApiUrl(),
    atsUrl: getAtsUrl(),
    subscriberInfo: localStorage.getItem('cc'),
  };
}

function createMetadata(title: PlayableTitle, isTrailer: boolean) {
  return {
    title: `${title.titleName} ${isTrailer ? '- Trailer' : ''}`,
    subtitle:
      title.season?.sequenceNumber && title.episode?.sequenceNumber
        ? `Season ${title.season?.sequenceNumber} Episode ${title.episode?.sequenceNumber}`
        : '',
  };
}
